import React from 'react'
import { Link } from 'react-router-dom'

import { ArrowLeftIcon } from '../../icons/ArrowLeftIcon'
import st from './backButton.module.scss'
import { ButtonProps } from './BackButton.types'

export const BackButton = ({ url, isWhite, classModifiers }: ButtonProps) => {
  const classList = classModifiers
    ? classModifiers.map((el: string) => `${st['button--' + el]}`)
    : []

  return (
    <Link
      className={`${st.button} ${classList?.join(' ')}`}
      to={url}
      id='backButton'
      style={isWhite ? { color: 'white' } : { color: 'black' }}
    >
      <ArrowLeftIcon />
    </Link>
  )
}
